import { render, staticRenderFns } from "./ExtraField.vue?vue&type=template&id=43528f26"
import script from "./ExtraField.vue?vue&type=script&lang=js"
export * from "./ExtraField.vue?vue&type=script&lang=js"
import style0 from "./ExtraField.vue?vue&type=style&index=0&id=43528f26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports